import { login } from './login';
import { forgot } from './forgot';
import { activate } from './activate';
import { confirmEmail } from './confirmEmail';

export const customReducers = {
  activate,
  forgot,
  login,
  confirmEmail
};
